import React from 'react'

import Link from 'next/link'

import { BannerBox, InsideLink, Overlay } from './styles'

import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

const Banner = () => (
	<section id='banner-corporate'>
		<Row className='w-full justify-center'>
			<BannerBox>
				<Overlay>
					<Row className='w-full flex-col justify-end p-6 sm:p-10'>
						<Row>
							<Text
								as='h2'
								className='font-weight-bold mb-2 text-3xl text-white'
							>
								Ecossistema para gestão estratégica de saúde mental
							</Text>
						</Row>
						<Row>
							<Text className='mb-3 max-w-[440px] leading-6 text-white'>
								Além do cuidado individual, a Vittude atua com empresas por meio
								de um ecossistema completo de soluções em saúde mental
								organizacional. Diagnóstico, acompanhamento, educação e dados
								que apoiam decisões mais responsáveis e sustentáveis.
							</Text>
						</Row>
						<Link
							href={`${process.env.VITTUDE_OFFLINE_URL}/empresas`}
							passHref={true}
							legacyBehavior
						>
							<InsideLink target='_blank' rel='noreferrer'>
								<Button
									variant='primary-refit'
									id='test-banner'
									className='h-12 bg-white text-sm font-semibold italic leading-[19px] text-gray-800'
								>
									Saiba Mais
								</Button>
							</InsideLink>
						</Link>
					</Row>
				</Overlay>
			</BannerBox>
		</Row>
	</section>
)

export default Banner
